import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  DialogContentText,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { DialogDefaultV2 } from '../../../../components/v2';
import {
  EXPORT_SERVICO_APENAS_DIGITADOS,
  EXPORT_SERVICO_APENAS_DIGITADOS_LABELS,
} from '../constants';

const ExportServicosDialog = ({ open, onClose, onConfirm, message }) => {
  const [apenasDigitados, setApenasDigitados] = useState(
    EXPORT_SERVICO_APENAS_DIGITADOS.APENAS_DIGITADOS,
  );

  useEffect(() => {
    if (open) {
      setApenasDigitados(EXPORT_SERVICO_APENAS_DIGITADOS.APENAS_DIGITADOS);
    }
  }, [open]);

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={() => onConfirm(apenasDigitados)}
      title="Exportar Serviços"
      confirmMessage="Exportar"
    >
      <DialogContentText>{message}</DialogContentText>
      <FormControl component="fieldset" sx={{ mt: 1 }}>
        <RadioGroup
          value={String(apenasDigitados)}
          onChange={(e) => setApenasDigitados(e.target.value === 'true')}
        >
          <FormControlLabel
            value={String(EXPORT_SERVICO_APENAS_DIGITADOS.APENAS_DIGITADOS)}
            control={<Radio color="primary" />}
            label={EXPORT_SERVICO_APENAS_DIGITADOS_LABELS[true]}
          />
          <FormControlLabel
            value={String(EXPORT_SERVICO_APENAS_DIGITADOS.TODOS_INSPECIONADOS)}
            control={<Radio color="primary" />}
            label={EXPORT_SERVICO_APENAS_DIGITADOS_LABELS[false]}
          />
        </RadioGroup>
      </FormControl>
    </DialogDefaultV2>
  );
};

ExportServicosDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default ExportServicosDialog;
